import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../../../global/commonStyle';

const Content = styled.div`
  ${FlexBetween}
  padding-block: var(--space-10);
  gap: var(--space-24);
  position: sticky;
  top: 0;
  background-color: var(--background-secondary);
  z-index: var(--z-index-header);
`;

const HeaderBlock = styled.div`
  display: flex;
`;

const Heading = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;

const Title = styled.h1`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: var(--space-0);
  white-space: nowrap;
`;

const Menu = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  .active {
    display: inline-flex;
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-8);
  }
  ${mobile_xl(css`
    gap: var(--space-18);
  `)}
`;

const HeaderBtn = styled.div``;

export { Content, HeaderBlock, Heading, Title, Menu, HeaderBtn };
